module.exports = __webpack_public_path__ + "static/media/IHH_72_color.28dc4180.png";